<div>
    <label>{{'_General_Location_Text_' | translate }}</label>
    <ng-multiselect-dropdown name="locations" [ngModel]="selectedLocations$ | async" placeholder="{{'_General_Select_Text_' | translate }}" 
        [data]="allLocations$ | async" [settings]="dropdownSettings" (onSelect)="onItemSelect($event)"
        (onSelectAll)="onSelectAll($event)" (onDeSelect)="onDeSelect($event)" (onDeSelectAll)="onDeSelectAll($event)">
    </ng-multiselect-dropdown>
</div>